export default __webpack_public_path__ + "static/partnersBanner-5b8971b500602576e6e1d06df78f4e60.png";